/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SuiviService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Repartition des projets par categorie de suivi
     * Compte les projets crees entre `DATE_DEBUT` et `DATE_FIN` dans chaque categorie. Reponse : `{ <categorie>: <nombre> }`. Meme cache que `suivi/list` (`X-Cached-At`, `force_refresh`).
     * @param dateDebut
     * @param dateFin
     * @param forceRefresh
     * @returns string
     * @throws ApiError
     */
    public suiviStats(
        dateDebut: string,
        dateFin: string,
        forceRefresh?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/suivi/stats',
            query: {
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
                'force_refresh': forceRefresh,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Projets d'une categorie de suivi
     * Projets crees entre `DATE_DEBUT` et `DATE_FIN` dans la categorie `type` (a affecter, a contacter, sans rendez-vous, sans devis, avec devis, devis signe, annule, sans suite), optionnellement pour un responsable (`personnel_id`). Le resultat est mis en cache : les en-tetes `X-Cached-At` et `X-Cache-TTL` le datent, `force_refresh=1` le recalcule.
     * @param dateDebut
     * @param dateFin
     * @param type
     * @param personnelId
     * @param forceRefresh
     * @returns string
     * @throws ApiError
     */
    public suiviList(
        dateDebut: string,
        dateFin: string,
        type: 'to_assignment' | 'to_contact' | 'without_rdv' | 'without_quote' | 'with_quote' | 'with_signed_quote' | 'annule' | 'sans_suite',
        personnelId?: number | null,
        forceRefresh?: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/suivi/list',
            query: {
                'DATE_DEBUT': dateDebut,
                'DATE_FIN': dateFin,
                'type': type,
                'personnel_id': personnelId,
                'force_refresh': forceRefresh,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
}
